<form (ngSubmit)="save()" [formGroup]="roleForm">
	<div [alarisLoading]="rolesService.loading$">
		<div class="edit-panel-header">
			<alaris-icon name="icon-add-contact"></alaris-icon>
			{{ role.ID ? ('users_roles.roles.edit' | translate) : ('users_roles.roles.create' | translate) }}
		</div>
		<div [alarisFade]="'vertical'" class="form-group panel-content">
			<alaris-input formControlName="name" [errors]="errors">
				{{ 'users_roles.roles.name' | translate }}
			</alaris-input>

			<alaris-multi-select2 [label]="'users_roles.roles.rolePermissions' | translate"
								  [optionsCount]="rolesService.permissions.length"
								  [showAllSelected]="true"
								  formControlName="permissions" mode="tag" [errors]="errors">
				@for (permission of rolesService.permissions; track permission) {
				<alaris-multi-options2 [value]="permission">{{ permission }}</alaris-multi-options2>
				}
			</alaris-multi-select2>
			<button (click)="reset()" alaris-button bType="secondary" class="reset-button" size="lg" type="button">
				<alaris-icon name="icon-refresh-clock-wise"></alaris-icon>
				{{ 'gl.reset' | translate }}
			</button>
		</div>
		<div class="edit-panel-footer">
			<button [disabled]="roleForm.invalid || !roleForm.dirty"
					alaris-button bType="primary"
					size="lg"
					type="submit">
				<alaris-icon class="in-primary" name="icon-success"></alaris-icon>
				{{ 'gl.submit' | translate }}
			</button>
			<button (click)="close()" alaris-button bType="outline" size="lg" type="button">
				{{ 'actions.close' | translate }}
			</button>
		</div>
	</div>
</form>

